module.exports = __webpack_public_path__ + "static/media/evah-ia-icon.f3570885.svg";